import styled from 'styled-components';
import { device } from '../../../helpers/style';
import src from './images/become-an-author.png';

export const Container = styled.div`
    margin: 40px auto 60px auto;
    display: none;
    flex-direction: row;
    justify-content: center;

    @media ${device.phone} {
        display: flex;
    }
`;

const s = 0.8;
const w = 315 * s;
const h = 126 * s;
const Img = styled.img`
    width: ${w}px;
    height: ${h}px;
`;

function onClick() {
    window.location.assign('/app/login?tab=register');
}

export default function Invite({ counter }: { counter: number }) {
    // if (counter === 0 || counter % 5 !== 0) {
    //     return null
    // }

    return (
        <Container>
            <Img src={src} alt="مصنف بنئے" onClick={onClick} />
        </Container>
    );
}
